riot.tag2('acr-svg', '', '', '', function(opts) {
    var self = this;
    var Acr = window.Acr ? window.Acr : {};
    var acrSvgs;
    var svgElement;
    self.svgClass;
    self.viewBox;
    self.content;
    self.svgFocusable;

    function createSVG(){
      var svgElement = document.createElement("svg");
      for (var i = 0; i < self.content.childElementCount; i++) {
        var node = self.content.childNodes[i].cloneNode(true);
        svgElement.appendChild(node);
      }
      if (self.viewBox) {
        svgElement.setAttribute("viewBox", self.viewBox);
      }
      if (self.svgClass) {
        svgElement.setAttribute("class", self.svgClass);
      }
      if (self.svgFocusable) {
        svgElement.setAttribute("focusable", self.svgFocusable);
      }
      return svgElement.outerHTML;
    }

    function insertSVG(){
      acrSvgs = Acr.SvgList;
      svgElement = acrSvgs[opts.svgId];
      if(svgElement) {
        self.svgFocusable = opts.svgFocusable;
        self.svgClass = opts.svgClass ? opts.svgClass : '';
        self.viewBox = svgElement.viewBox  ? svgElement.viewBox : opts.svgViewbox;
        self.content = svgElement.content;
        self.root.innerHTML = createSVG();
      }
    }

    this.on('mount', function mount(){
      if(Acr.svgLoadedInMemory){
        insertSVG();
      }
      else {
        window.addEventListener('svgsLoaded', insertSVG);
      }
    });

    this.on('update', function update() {
      if(Acr.svgLoadedInMemory){
        acrSvgs = Acr.SvgList;
        svgElement = acrSvgs[opts.svgId];
        if(svgElement) {
          self.content = svgElement.content
          self.root.innerHTML = createSVG();
        }
      }
    });
});